
namespace TabAurous.Finance {

    @Serenity.Decorators.registerClass()
    export class ServiceInwardGrid extends _Ext.GridBase<ServiceInwardRow, any> {
        protected getColumnsKey() { return 'Finance.ServiceInward'; }
        protected getDialogType() { return ServiceInwardDialog; }
        protected getIdProperty() { return ServiceInwardRow.idProperty; }
        protected getInsertPermission() { return ServiceInwardRow.insertPermission; }
        protected getLocalTextPrefix() { return ServiceInwardRow.localTextPrefix; }
        protected getService() { return ServiceInwardService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
        protected addButtonClick() {

            let now = new Date(); 
            var userDefinition = Q.Authorization.userDefinition;
            var voucherNo = FormatHelper.GetVoucherNo(95);
            this.editItem(<ServiceInwardRow>{
                VoucherNo: voucherNo,
                TransDate: now.toString(),
                CreatedBy: userDefinition.UserId,
                VoucherTypeId: 95,
                FinancialYearId: userDefinition.FinancialYearId,
                CompanyId: userDefinition.CompanyId, 
                UserId: userDefinition.UserId,
                CurrencyId: userDefinition.CurrencyId,
                EnteredBy: userDefinition.Username,
                
            });
        }
    }
}